import { AdvertisementType } from "@cryptors/api-client";
import { zodResolver } from "@hookform/resolvers/zod";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, IconButton } from "@mui/material";
import { Edit } from "@refinedev/mui";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { z } from "zod";

import { useGetCryptor, usePatchCryptor } from "@/api/cryptor.api";

import CryptorAdvertisementsField from "./components/CryptorAdvertisementsField";

const CryptorAdvertisementsSchema = z.object({
  storyAdvertisements: z.array(z.number()),
  discussionAdvertisements: z.array(z.number()),
});

type CryptorAdvertisementsFormData = z.infer<
  typeof CryptorAdvertisementsSchema
>;

const CryptorAdvertisementsEdit = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cryptorId = Number(searchParams.get("cryptorId"));

  const { data: cryptor, isLoading } = useGetCryptor(cryptorId);
  const { mutateAsync: patchCryptor } = usePatchCryptor();

  const { control, reset, handleSubmit } =
    useForm<CryptorAdvertisementsFormData>({
      resolver: zodResolver(CryptorAdvertisementsSchema),
      mode: "onChange",
      defaultValues: { storyAdvertisements: [], discussionAdvertisements: [] },
    });

  useEffect(() => {
    if (!cryptor) return;
    reset({
      storyAdvertisements: cryptor.advertisements
        .filter((link) => link.type === AdvertisementType.STORY)
        .map((link) => link.advertisement.id),
      discussionAdvertisements: cryptor.advertisements
        .filter((link) => link.type === AdvertisementType.DISCUSSION)
        .map((link) => link.advertisement.id),
    });
  }, [reset, cryptor]);

  const onFinishHandler = async (data: CryptorAdvertisementsFormData) => {
    await patchCryptor({
      id: cryptorId,
      storyAdvertisements: data.storyAdvertisements.map((id) => ({ id })),
      discussionAdvertisements: data.discussionAdvertisements.map((id) => ({
        id,
      })),
    });
    navigate(-1);
  };

  return (
    <Edit
      goBack={
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBack />
        </IconButton>
      }
      headerButtons={() => null}
      isLoading={isLoading}
      saveButtonProps={{ onClick: handleSubmit(onFinishHandler) }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <CryptorAdvertisementsField
          control={control}
          name="storyAdvertisements"
          title="Publicités (histoire / quiz)"
        />
        <CryptorAdvertisementsField
          control={control}
          name="discussionAdvertisements"
          title="Publicités (discussion IA)"
        />
      </Box>
    </Edit>
  );
};

export default CryptorAdvertisementsEdit;
